/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Aspect_Instagram_PortraitInputs */

const cs_template_aspect_instagram_portrait = /** @type {(inputs: Template_Aspect_Instagram_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram na výšku`)
};

const en_template_aspect_instagram_portrait = /** @type {(inputs: Template_Aspect_Instagram_PortraitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram portrait`)
};

/**
* | output |
* | --- |
* | "Instagram portrait" |
*
* @param {Template_Aspect_Instagram_PortraitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const template_aspect_instagram_portrait = /** @type {((inputs?: Template_Aspect_Instagram_PortraitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Aspect_Instagram_PortraitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_aspect_instagram_portrait(inputs)
	return cs_template_aspect_instagram_portrait(inputs)
});